/** Cooperativa activa para sesión (root u operador). Ver docs/CARACTERISTICAS_SISTEMA.md §4.2 */
const KEY_ID = 'cooperativa_active_id';
const KEY_SLUG = 'cooperativa_active_slug';
/** Tras abrir workspace desde root («Editar sitio»), abre esta sub-vista de Administración una sola vez. */
const KEY_PENDING_ADMIN_VISTA = 'cooperativa_pending_admin_vista';

export function getActiveCooperativaId(): string | null {
  try {
    const v = localStorage.getItem(KEY_ID);
    return v?.trim() || null;
  } catch {
    return null;
  }
}

export function getActiveCooperativaSlug(): string | null {
  try {
    const v = localStorage.getItem(KEY_SLUG);
    return v?.trim() || null;
  } catch {
    return null;
  }
}

export function setPendingAdminVista(vista: string | null): void {
  try {
    const v = vista?.trim();
    if (v) {
      sessionStorage.setItem(KEY_PENDING_ADMIN_VISTA, v);
    } else {
      sessionStorage.removeItem(KEY_PENDING_ADMIN_VISTA);
    }
  } catch {
    /* ignore */
  }
}

/** Lee y borra la vista pendiente (una sola vez por apertura de workspace). */
export function consumePendingAdminVista(): string | null {
  try {
    const v = sessionStorage.getItem(KEY_PENDING_ADMIN_VISTA)?.trim();
    sessionStorage.removeItem(KEY_PENDING_ADMIN_VISTA);
    return v || null;
  } catch {
    return null;
  }
}

export function setActiveCooperativaId(cooperativaId: string | null, slug?: string | null): void {
  try {
    if (cooperativaId?.trim()) {
      localStorage.setItem(KEY_ID, cooperativaId.trim());
      if (slug?.trim()) {
        localStorage.setItem(KEY_SLUG, slug.trim());
      } else {
        localStorage.removeItem(KEY_SLUG);
      }
    } else {
      localStorage.removeItem(KEY_ID);
      localStorage.removeItem(KEY_SLUG);
    }
  } catch {
    /* ignore */
  }
}
